import { communityApi } from "@circle-react/api/communityApi";
import { useMutation } from "react-query";

export const useUpdateCommunity = (options = {}) => {
  const mutation = async payload => communityApi.update(payload);

  return useMutation({ mutationFn: mutation, ...options });
};
